export default __webpack_public_path__ + "static/cdtcloudblueprint-min-0adc296a889db33c8ac42cbaf658f122.gif";